export enum WebauthnLoginCredentialPrfStatus {
  Enabled = 0,
  Supported = 1,
  Unsupported = 2,
}
